export const colors = {
  black900: '#0E101A',
  white: '#FFFFFF',

  grey: '#ACB7FF',

  grey100: '#F4F4F5',
  grey200: '#E4E4E7',
  grey300: '#D4D4D8',
  grey400: '#A1A1AA',
  grey500: '#71717A',
  grey600: '#52525B',

  blue: '#2D68FF',
  hoverBlue: '#2D68FFCC',
  lightBlue: '#97B4FF',
  green: '#AAFE97',
  red: '#F35365',
  orange: '#F3A953',
  social: '#0D1531',
  inactive: '#151724',
  light1: '#494D6F',
  light2: '#626A95',
  darkBlue1: '#0E101A',
  darkBlue2: '#191C2C',
  darkBlue3: '#222539',
  darkBlue4: '#303348',

  transparent: '#00000000',
}

export type Colors = keyof typeof colors
